module.exports = __webpack_public_path__ + "static/media/vimeo-square.9f8b0484.svg";